import React, {useEffect} from 'react';
import useStakedAntDetails from '../hooks/useStakedAntDetails'; // Make sure the import path is correct
import WorkerAnt from './images/WorkForce.png';
import Tooltip from './Tooltip';

function StakedAntStats({ stakedNftAddress }) {
  const { level, remainPotions, isLoading } = useStakedAntDetails(stakedNftAddress);


  const formatAddress = (address) => {
    return address ? `${address.substring(0, 6)}...${address.substring(address.length - 6)}` : '';
  };

  // Function to copy the address to the clipboard
  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      // Placeholder feedback
      alert('Address copied to clipboard!');
    }, (err) => {
      console.error('Failed to copy address:', err);
    });
  };

  return (
    <div className="left-content">
      <div className={`Ant-class`}>
        <h1>Worker ANT</h1>
        <div className="class-image">
          {/* Assuming you want to dynamically display ANT images, you can adjust this part */}
          <img src={WorkerAnt} alt="Worker ANT" />
        </div>
      </div>
      <p style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(stakedNftAddress)}>
        {formatAddress(stakedNftAddress)}
      </p>
      <div className="level-container">
        <div className="level">
          <h2>{isLoading ? 'N/A' : level || 'N/A'}</h2> 
        </div>
        <div className="experience">
        <h2>{isLoading ? ' N/A ' : level === 40 ? 'MAX' : `${remainPotions || 0}/ ${level + 1}`}</h2>
        <Tooltip text="Ant's level and experience"></Tooltip> 
        </div>
      </div>
      <div className="divider" id="stats-divider"></div>
    </div>
  );
}

export default StakedAntStats;